module.exports = "<p>\n  captacao-forms-telephone works!\n</p>\n"